import { useMediaQuery } from '@material-ui/core'
import SmallProfileImage from 'components/auction/SmallProfileImage'
import ErrorLine from 'components/ErrorLine'
import { addReaction } from 'controllers/SocialServiceController'
import { deleteHighlightReactions } from 'controllers/SocialServiceController'
import { getReaction } from 'controllers/SocialServiceController'
import EmojiPicker from 'emoji-picker-react'
import { store } from 'index'
import moment from 'moment'
import { useEffect } from 'react'
import { useRef } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAccountId } from 'redux/actions/accountActions'
import { setReactorPlay } from 'redux/actions/displayActions'
import { io } from 'socket.io-client'
import { isVeryNarrow } from 'util/screenUtils'
import { logWithTime } from 'util/screenUtils'
import { displayError } from 'util/screenUtils'
import { getConnectionChannelForMessage } from 'util/socketUtils'
export const REACTOR_STYLE = {
    top: '60vh',
    bottom: '30vh',
    bottomY: '10vh'
}
export const REACTOR_REACTIONS = ['1f44d', '2764-fe0f', '1f603', '1f483', '1f57a', '1f3b8', '1f3b9', '1f941']
const REACTOR_HIGHLIGHT_START = '1f449'
let reactorLines = []
let socket
export default function Reactor({ controlRef }) {

    const veryNarrow = isVeryNarrow(useMediaQuery)
    const playerStyles = {
        controlIcon: {
            fontSize: veryNarrow ? '1.5em' : '2em',
            marginRight: veryNarrow ? '0.25em' : '1em'
        }
    }
    const { playListIndex } = useSelector(state => state.harmonize)
    const { playList } = useSelector(state => state.messages)
    const { currentPlayTime } = useSelector(state => state.reactor)
    const user = getAccountId()
    const [error, setError] = useState()
    const [receivedReaction, setReceivedReaction] = useState()
    const [displayReactorLines, setDisplayReactorLines] = useState([])
    const [joinedStudio, setJoinedStudio] = useState(false)
    const dispatch = useDispatch()
    const reactionsRef = useRef()

    const getSong = () => {
        return playList[playListIndex]
    }
    const isHighlightEmoji = (unifiedEmoji) => {
        return unifiedEmoji === REACTOR_HIGHLIGHT_START
    }
    const isOwner = () => {
        const { userId } = getSong()
        return (user === userId)
    }
    /**
     * Take the received emojiObject of {unifiedEmoji, user, playTime} and add a reaction
    * to the reactions array in reactorLines at currentPlayTime. The completed reactorLine
    * for a given playTime is then {reactorTime, reactions}.
    * 
    * If localReaction is true this is then posted to the server for the
    * current messageId.
    * 
    * If localReaction is true the Reaction is used to add an _id to the local reactionLine. This is needed
    * if that line is later deleted.
    *
    * The caller must ensure the Reaction added is targeted for the current messageId.
    *
    * The Reaction added to the Social Service db does not need user, since it is taken from the signed-in User.
    * When posted to the messageSocket, user is required so that when it is received at other session
    * listeners, the proper User profile image is displayed.
    * 
    * When a localReaction is created the playTime is taken directly from the redux reactor store because
    * useSelector is behind for some reason; otherwise from the
    * reaction received from the server.
    *
    * @param {*} reaction {unifiedEmoji, user, [playTime]} where user is the ID of the reacting User
    * @param {*} localReaction If true the reaction was created by this User, otherwise received from Social Service
    */
    const addMediaReaction = async (reaction, localReaction = true) => {
        const { currentPlayTime: reactionPlayTime } = store.getState().reactor
        console.log(`<*> addMediaReaction reactionPlayTime ${reactionPlayTime} localReaction ${localReaction}`, reaction)
        console.log('<*>...current reactorLines', reactorLines)
        const { unifiedEmoji, user } = reaction
        const playTime = localReaction ? reactionPlayTime : reaction.playTime
        const highlightReaction = isHighlightEmoji(unifiedEmoji)
        const reactionToPush = { user, unifiedEmoji }
        if (!localReaction) {
            //The _id of the existing reaction is required to delete any existing highlight reaction
            const { _id } = reaction
            reactionToPush._id = _id
        }
        let reactionTimeToDelete
        if (highlightReaction) {
            reactionToPush.highlightTime = playTime
            reactionTimeToDelete = removeExistingHighlightReaction()
        }
        const reactorLineIx = reactorLines.findIndex(r => r.reactorTime === playTime)
        if (reactorLineIx !== -1) {
            const reactorLine = reactorLines[reactorLineIx]
            console.log(`<*>Received new reaction at playTime ${playTime} ${reactorLine.reactorTime}`, reactorLine)
            reactorLine.reactions.push(reactionToPush)
            reactorLines.splice(reactorLineIx, 1, reactorLine)
            setDisplayReactorLines([...reactorLines])
        } else {
            const reactions = [reactionToPush]
            reactorLines.push({ reactorTime: playTime, reactions })
            reactorLines.sort((a, b) => {
                return a.reactorTime < b.reactorTime ? -1 : a.reactorTime > b.reactorTime ? 1 : 0
            })
            setDisplayReactorLines([...reactorLines])
        }
        //console.log(`reactorLines at ${playTime}`, reactorLines)
        if (localReaction) {
            try {
                const { _id: messageId } = getSong()
                const reaction = { messageId, unifiedEmoji, playTime }
                if (highlightReaction) {
                    reaction.highlightTime = playTime
                    if (reactionTimeToDelete) {
                        await deleteExistingHighlightReactions()
                    }
                }
                const updatedReaction = await addReaction(reaction)
                logWithTime('<*>added reaction to Social Service', updatedReaction)
                //Send this reaction to all other users in the Studio
                socket.emit('reaction', { ...reaction, user })
            } catch (error) {
                displayError(error, setError, 7)
            }
        }
        scrollToBottom()
    }

    const createReaction = (emojiObject) => {
        const { unified: unifiedEmoji } = emojiObject
        return { unifiedEmoji, user }
    }
    /**
     * Delete all highlight reactions for the current Message
     */
    const deleteExistingHighlightReactions = async () => {
        console.log(`<*>deleteHighlightReactions`, reactorLines)

        const { _id: messageId } = getSong()
        try {
            await deleteHighlightReactions(messageId)
        } catch (error) {
            displayError(error, setError)
        }

    }

    /**
     * This searches all reactions in reactorLines until there is a
     * highlightEmoji in the reaction. If found:
     * 1) The reaction is removed from reactions
     * 2) All existing highlights are removed from the Message in Social Service
     * @returns 
     */
    const removeExistingHighlightReaction = () => {
        let reactorIx = 0, reactionTimeToDelete
        const updatedReactorLines = [...reactorLines]
        console.log('<*>removeExistingHighlightReaction', updatedReactorLines)
        for (let reactorLine of reactorLines) {
            console.log(`<*>...reactorIx ${reactorIx}`, reactorLine)
            const { reactions } = reactorLine
            const ix = reactions.findIndex(r => isHighlightEmoji(r.unifiedEmoji))
            if (ix !== -1) {
                console.log(`...highlight reaction at ${ix}`, reactions[ix])
                const { highlightTime } = reactions[ix]
                reactionTimeToDelete = highlightTime
                reactions.splice(ix, 1)
                if (reactions.length) {
                    const updatedReactorLine = { ...reactorLine, reactions }
                    console.log(`<*>Found existing highlight at ${reactorIx}`, updatedReactorLine)
                    reactorLines.splice(reactorIx, 1, updatedReactorLine)
                } else {
                    console.log(`<*>Found existing highlight at ${reactorIx}, deleted reactor line`, reactorLine)
                    reactorLines.splice(reactorIx, 1)
                }
                setDisplayReactorLines([...reactorLines])
                break
            }
            reactorIx++
        }
        console.log(`<*>removeExistingHighlightReaction returned ${reactionTimeToDelete}`, reactorLines)
        return reactionTimeToDelete
    }

    /**
     * @returns 
     */
    const displayReactionsOrPicker = () => {

        const reactions = [...REACTOR_REACTIONS]
        if (isOwner()) {
            reactions.push(REACTOR_HIGHLIGHT_START)
        }
        return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <EmojiPicker
                    reactionsDefaultOpen={true}
                    allowExpandReactions={false}
                    reactions={reactions}
                    searchDisabled={true}
                    autoFocusSearch={false}
                    onReactionClick={(eo) => {
                        addMediaReaction(createReaction(eo), true)
                        //setShowReactions(true)
                    }}
                />
                {/*
                     We are not yet allowing expanded Enoji selection
                    <Add style={playerStyles.controlIcon} onClick={() => {
                        setShowReactions(false)
                    }} />*/}
            </div>)


    }
    const getReactionsForEntry = () => {
        const { messageId } = getSong()
        populateReactions(messageId)
    }

    /**
     * Get Reactions for this Message, then start reactorPlay. If Reactions cannot be retrieved
     * reactorPlay does not start.
     * 
     * reactorTime uniquely identifies a single reactorLine in the reactorLines array
     */
    const populateReactions = async (messageId) => {
        try {
            const reactorReactions = await getReaction(messageId)
            console.log(`<*>reactions for ${messageId}`, reactorReactions)
            const { highlightTime, playTimes } = reactorReactions

            reactorLines = []
            playTimes.forEach(r => {
                const { time: reactorTime, reactions } = r
                reactorLines.push({ reactorTime, reactions, highlightTime })
            })
            setDisplayReactorLines(reactorLines)
            dispatch(setReactorPlay(true))
            scrollToBottom()
        } catch (error) {
            displayError(error, setError, 6)
        }
    }

    /**
     * It appears that the unifiedEmoji may comprise multiple hyphen-separated values. To solve this see:
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
     * and
     * https://www.bennadel.com/blog/4084-rending-emoji-glyphs-using-hexadecimal-codepoints-in-javascript.htm
     * @param {*} reaction
                        * @param {*} ix
                        * @returns
                        */
    const displayReaction = (reaction, ix) => {
        const { unifiedEmoji, user } = reaction
        const actualEmoji = unifiedEmoji.split('-')
        const codePoints = []
        actualEmoji.forEach(e => {
            codePoints.push(parseInt(e, 16))
        })
        try {
            return (
                <div key={ix} style={{ display: 'flex', alignItems: 'center', overflowX: 'auto' }}>
                    <SmallProfileImage userId={user} />
                    {String.fromCodePoint.apply(null, codePoints)}
                </div>
            )
        } catch (error) {
            console.error(`Bad ${unifiedEmoji}`, error)
        }

    }

    /**
     * 
     * @param {*} l {_id,user,unifiedEmoji,isHighlight}
     * @returns 
     */
    const displayReactionLine = (l) => {
        //console.log(`displayReactionLine currentPlayTime ${currentPlayTime}`)
        const { reactorTime, reactions } = l
        const displayDuration = moment.duration(reactorTime, 'seconds')
        const backgroundColor = reactorTime === currentPlayTime ? 'gold' : 'white'
        return (
            <div key={reactorTime} style={{ display: 'flex', paddingLeft: '0.5em', backgroundColor, alignItems: 'center' }}
                onClick={(evt) => {
                    evt.stopPropagation()
                    controlRef.current.seekTo(reactorTime)
                }}>
                {displayDuration.format(reactorTime >= 60 ? 'm:ss' : '0:ss')} {
                    reactions.map((r, ix) => displayReaction(r, ix))}
            </div>
        )
    }
    const scrollToBottom = () => {
        //console.log(`scrollToBottom`, targetRef)
        if (reactionsRef.current) {
            const scroll = reactionsRef.current.scrollHeight -
                reactionsRef.current.clientHeight
            reactionsRef.current.scrollTo(0, scroll)
        }
    }
    const displayReactions = () => {
        if (joinedStudio) {
            return (
                <div>
                    <ErrorLine error={error} />
                    {displayReactionsOrPicker()}
                    <div ref={reactionsRef}
                        style={{ height: '20vh', overflowY: 'auto', overscrollBehavior: 'contain' }}>
                        {displayReactorLines.map(l => displayReactionLine(l))}
                    </div>
                </div>
            )
        } else {
            return null
        }
    }
    /**
   * We only need a Studio connection when creating or updating a Message.
   */
    const connectStudio = () => {
        try {
            const channelAddress = `${process.env.REACT_APP_SOCIAL_CHAT_SERVICE}${getConnectionChannelForMessage(getSong())}`
            console.log(`{}Reactor connect to ${channelAddress}`)
            socket = io(channelAddress, {
                reconnectionDelay: 10000
            })
            //socketActions(socket, channel, studioOwner)
            socket.on('joined', () => {
                console.log('Reactor joined studio')
                setJoinedStudio(true)
            })
            socket.on('reaction', async (reaction) => {
                setReceivedReaction(reaction)
            })
            socket.on('unauthorized', () => {
                socket.disconnect()
                setError('You are not signed in')
            })
        } catch (error) {
            displayError(error, setError, 30)
        }
    }

    useEffect(() => {
        if (receivedReaction) {
            const { messageId: reactionMessageId } = receivedReaction
            logWithTime(`useEffect received reaction for ${reactionMessageId} 
            current messageId ${getSong().messageId}`, receivedReaction)
            if (getSong().messageId === reactionMessageId) {
                addMediaReaction(receivedReaction, false)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [receivedReaction])

    useEffect(() => {
        getReactionsForEntry()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playListIndex])
    useEffect(() => {
        console.log('Reactor useEffect', socket)
        connectStudio()
        return () => {
            dispatch(setReactorPlay(false))
            if (socket) {
                socket.disconnect()
            }
        }
    }, [])

    return displayReactions()
}